import { render, staticRenderFns } from "./LeagueTable.vue?vue&type=template&id=ae037bca&"
import script from "./LeagueTable.vue?vue&type=script&lang=js&"
export * from "./LeagueTable.vue?vue&type=script&lang=js&"
import style0 from "./LeagueTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports